import { Link } from "react-router-dom";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IconMacLogo } from "@icons";
import { getSectionId } from "@helpers";
import { routeNames } from "@core/routeNames";
import "./MacDetailsHeader.scss";

// Same MAC explainer as the Trending Now MACs header (MacsHeader).
export const MAC_DIAGRAM_URL = 'https://ds-projects-shared.s3.us-west-2.amazonaws.com/snap/MAC_DIAGRAM.pdf';

function MacDetailsHeader() {
    return (
        <header className="MacDetailsHeader" data-testid="blockMacDetailsHeader">
            <IconMacLogo className="MacDetailsHeader__logo" aria-label="MAC, Menu Adoption Cycle"/>
            <p className="MacDetailsHeader__description">
                The MAC, Menu Adoption Cycle, tracks foods, beverages, and
                ingredients along their trend curve across 4-stages:
                <br/>
                Inception, Adoption, Proliferation, and Ubiquity.
                <a
                    href={MAC_DIAGRAM_URL}
                    target="_blank"
                    title="Download information"
                    aria-label="Download information"
                    rel="noreferrer"
                    className="MacDetailsHeader__info"
                    data-testid="buttonMacDetailsDownloadInfo"
                >
                    <AiOutlineInfoCircle/>
                </a>
            </p>
            <Link
                to={{ pathname: routeNames.trendingNow, hash: `#${getSectionId('mac')}` }}
                className="MacDetailsHeader__back-link"
                data-testid="buttonMacDetailsBackToList"
            >
                view all MACs
            </Link>
        </header>
    );
}

export default MacDetailsHeader;
